import React from 'react'
import "./Auth.scss"
import { TextField,Button,Alert } from '@mui/material'
import axios from 'axios'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {setUser,getUserInfo} from '../redux/user/userActions'
import checkblack from '../Images/checkblack.png'
import checkgreen from '../Images/checkgreen.png'

function MS2(props) {
    console.log("verify otp props", props)
    const [error,setError]=React.useState("")
    const [otp,setOtp]=React.useState("")
    const [timer,setTimer]=React.useState(0)

    React.useEffect(()=>{
        if(timer>0){
            setTimeout(() => {
                setTimer(timer-1)
            }, 1000);
        }
    },[timer])

    const getUser = (otp)=>{
        // if(props.location.state.data.mobileNo){
        //  props.history.push('/ms3',{data:props.location.state.data})   
        // }
        axios.post(`${process.env.REACT_APP_DEVELOPMENT}/api/auth/verifyOtpMerchant`,{...props.location.state.data,otp})
        .then(res=>{
            console.log(res)
            props.setUser(res.data.result)
            props.getUserInfo(res.data.result)
            props.history.push('/ms3',{data:props.location.state.data})   
            // if(res.status===201){
            //     setError(res.data.result)
            // }else{
            //     if(res.data.role==="merchant"){
            //         props.setUser(res.data.result)
            //         props.getUserInfo(res.data.result)
            //         props.history.push('/merchantprofile')
            //     }else{
            //     props.setUser(res.data.result)
            //     props.getUserInfo(res.data.result)
            //     props.history.push(props.location.state.auth)        
            //     }
            // }
            // if(res.data.result!=="Incorrect" && res.data.result!=="Not Found"){
            //     props.setUser(res.data.result)
            //     props.getUserInfo(res.data.result)
            //     props.history.push(props.location.state.auth)
                
            // }else{
            //     setError(res.data.result)
            // }
            
        })
        .catch(err=>{
            console.log(err.response)
            if(err.response.data){
                setError(err.response.data)
            }
            
        })
    }

    const handleSubmit = ()=>{
        // if(otp===props.location.state.data.otp){
        //    getUser()
        // }else{
        //     setError("Invalid OTP")
        // }
        getUser(otp)
    }

    const handleOtpChange = (otpm)=>{
        setOtp(parseInt(otpm))
        // if(parseInt(otpm)===props.location.state.data.otp){
        //    getUser()
        // }
        if(parseInt(otpm).length===6){
            getUser(otpm)
        }
    }

  return (
    <div className='body'>
    <div className="shadow-sm auth-container">
        <img src="/cleverpeblack.png" alt="cleverpe" className="logo" />
        <h3>Be Clever Pe Later</h3>
        <h6>OTP has been sent to {props.location.state.data.mobileNo}</h6>
            <section>
                <p className="mototext">You're just two steps away to become a CleverPe Merchant !!</p>
            </section>

        <p style={{color:"#ccc"}}>{props.location.state.data.otp}</p>
        <TextField onChange={(e)=>handleOtpChange(e.target.value)} className="textfield" fullWidth variant="outlined" id="outlined-basic" label="Enter OTP" />
        <div style={{textAlign:"right"}}>
            {timer!==0?<Button disabled>Resend OTP ({timer})</Button>:<Button onClick={()=>setTimer(59)}>Resend OTP</Button>}
        </div>
        {error.length>0&&<Alert className="alert" severity="error">{error}</Alert>}
        <p className="grey subtitle my-3">By continuing, you agree to CleverPe <Link to="/termsandconditions">Terms and Conditions</Link> of Use and <Link to="/privacypolicy">Privacy Policy</Link>.</p>
        <Button onClick={()=>handleSubmit()} className="mt-2" fullWidth variant="contained">Verify OTP</Button>
        <p className='grey subtitle mt-3'>
        ©2022 Cleverpe Technologies Private Limited
    </p>
    </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch)=>{
    return {
        setUser:(token)=>dispatch(setUser(token)),
        getUserInfo:(token)=>dispatch(getUserInfo(token))
    }
}

export default connect(null,mapDispatchToProps)(MS2)